import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import useUserStore from "../../utils/storeApp";

function SystemErrors() {
  const {
    isUserLogedIn,
    userRole,
    userToken,
    sharedObject,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    const getMsg = async () => {
      const logUsr = sharedObject.ResponseCode;
      setError(logUsr);
      if (logUsr && logUsr !== "" && logUsr !== "SUCCESS") {
        setFlag(true);
        //$(".modal").modal("hide");
      }
      if (error === "ECONNABORTED") {
        $(".modal").modal("hide");
      }
    };
    getMsg();
    console.log(sharedObject.ResponseCode);
  }, [sharedObject.ResponseCode]);

  return (
    <div className="SystemErrors">
      {flag ? (
        <section className="sp-margin1">
          {error === "ECONNABORTED" ? (
            <div className="alert alert-danger">
              We have encountered an system error and it is not responding.
              Please try again and contact support if the problem persists.
            </div>
          ) : error === "REGISTRATIONERROR" ? (
            <div className="alert alert-danger">
              A system error occurred during registration. Please contact
              support for further assistance.
            </div>
          ) : error === "SEARCHERROR" ? (
            <div className="alert alert-danger">
              A system error occurred searching for your results. Please contact
              support for further assistance.
            </div>
          ) : error === "VALIDATIONERROR" ? (
            <div className="alert alert-danger">
              A system error occurred validating for your results. Please
              contact support for further assistance.
            </div>
          ) : error === "SERVERERROR" ? (
            <div className="alert alert-danger">
              We have encountered a system error. Please try again and contact
              support if the problem persists.
            </div>
          ) : error === "FORBIDDEN" ? (
            <div className="alert alert-danger">
              We have encountered an forbidden error. Please try again and
              contact support if the problem persists.
            </div>
          ) : null}
        </section>
      ) : null}
    </div>
  );
}

export default SystemErrors;
